// console.log('------------------qqqqqqqqqqqss')
//   document.querySelectorAll('.custom-variant-option-selector').forEach(function(selector) {
//     selector.addEventListener('change', function() {
//         console.log('test');
//         var selectedValues = [];
        
//         // Get all select elements within the same .sf__pcard-action-atc parent
//         var variantOptions = this.closest('.sf__pcard').querySelectorAll('.custom-variant-option-selector select');
//         console.log(variantOptions);
        
//         variantOptions.forEach(function(option) {
//             // Check if there's a valid selected option
//             console.log('option ',option)
//             if (option.selectedIndex !== -1) {
//                 var selectedValue = option.options[option.selectedIndex].value;
//                 console.log('selectedValue ', selectedValue);
//                 selectedValues.push(selectedValue);
//             }
//         });
        
//         var displayValue = selectedValues.join(' / ');
//         console.log('displayValue ', displayValue);
        
//         // Find the .variant-option-js within the same parent and update its value
//         var variantOptionElement = this.closest('.sf__pcard').querySelector('.variant-option-js');
//         if (variantOptionElement) {
//             variantOptionElement.value = displayValue;
//             variantOptionElement.dispatchEvent(new Event('change'));
            
//             var selectedVarId = parseInt(variantOptionElement.options[variantOptionElement.selectedIndex]?.getAttribute("data-id"));

//            var grid_product_price = variantOptionElement.options[variantOptionElement.selectedIndex]?.getAttribute('data-variant-price');
//       // console.log('grid_product_price ',grid_product_price)
//           this.closest('.product-form').querySelector('.prod__price').textContent = grid_product_price;

//                      var grid_product_compare_price = variantOptionElement.options[variantOptionElement.selectedIndex]?.getAttribute('data-variant-compare-price');
//       // console.log('grid_product_compare_price ',grid_product_compare_price)
//           this.closest('.product-form').querySelector('.prod__compare_price').textContent = grid_product_compare_price;
//           if(grid_product_price == grid_product_compare_price){
//                this.closest('.product-form').querySelector('.prod__compare_price').classList.add('hidden');
//           }else{
//                this.closest('.product-form').querySelector('.prod__compare_price').classList.remove('hidden');
//           }
//  var grid_product_image = variantOptionElement.options[variantOptionElement.selectedIndex]?.getAttribute('data-image');
//        console.log('grid_product_image ',grid_product_image)
//           this.closest('.product-form').querySelector('.sf-image img').setAttribute("srcset",grid_product_image);          
          

//         var inputIdElement = this.closest('.product-form ').querySelector('input[name="id"]');
//             console.log('inputIdElement ',inputIdElement)
//             if (inputIdElement) {
//                 console.log('selectedVarId ', selectedVarId);
//                 console.log('Before -- inputIdElement.value ',inputIdElement.value)
//                 inputIdElement.value = selectedVarId;
//                     console.log('After -inputIdElement.value ',inputIdElement.value)
//             }
//             setTimeout(function(){                        
//             console.log('inputIdElement after ',inputIdElement)
//                 },1000)
//         }
//     });
// });



console.log('------------------qqqqqqqqqqqss');

$(document).on('change', '.custom-variant-option-selector', function() {

    console.log('test');
    var selectedValues = [];
    
    // Get all select elements within the same .sf__pcard parent
    var variantOptions = $(this).closest('.sf__pcard').find('.custom-variant-option-selector select');
    console.log(variantOptions);
    
    variantOptions.each(function() {
        console.log('option ', this);
        if (this.selectedIndex !== -1) {
            var selectedValue = $(this).find('option:selected').val();
            console.log('selectedValue ', selectedValue);
            selectedValues.push(selectedValue);
        }
    });
    
    var displayValue = selectedValues.join(' / ');
    console.log('displayValue ', displayValue);
    
    // Find the .variant-option-js within the same parent and update its value
    var variantOptionElement = $(this).closest('.sf__pcard').find('.variant-option-js');
    if (variantOptionElement.length) {
        variantOptionElement.val(displayValue).trigger('change');
        
        var selectedVarId = parseInt(variantOptionElement.find('option:selected').data('id'));
        
        var grid_product_price = variantOptionElement.find('option:selected').data('variant-price');
        console.log('grid_product_price ', grid_product_price);
        $(this).closest('.product-form').find('.prod__price').text(grid_product_price);
        
        var grid_product_compare_price = variantOptionElement.find('option:selected').data('variant-compare-price');
        console.log('grid_product_compare_price ', grid_product_compare_price);
        $(this).closest('.product-form').find('.prod__compare_price').text(grid_product_compare_price);

        if (grid_product_price == grid_product_compare_price) {
            $(this).closest('.product-form').find('.prod__compare_price').addClass('hidden');
          console.log('yes matched')
          $(this).closest('.product-form').find('.prod__compare_price').text('')
        } else {
            $(this).closest('.product-form').find('.prod__compare_price').removeClass('hidden');          
          console.log('not matched')
        }

        var grid_product_image = variantOptionElement.find('option:selected').data('image');
        console.log('grid_product_image ', grid_product_image);
        $(this).closest('.product-form').find('.sf-image img').attr("srcset", grid_product_image);

        var inputIdElement = $(this).closest('.product-form').find('input[name="id"]');
        console.log('inputIdElement ', inputIdElement);
        if (inputIdElement.length) {
            console.log('selectedVarId ', selectedVarId);
            console.log('Before -- inputIdElement.val()', inputIdElement.val());
            inputIdElement.val(selectedVarId);
            console.log('After -- inputIdElement.val()', inputIdElement.val());
        }
        
        setTimeout(function() {                        
            console.log('inputIdElement after ', inputIdElement.val());
        }, 1000);
    }
});



      $(document).on('change', '.drawer-custom-variant-option-selector', function() {
        
            console.log('test');
            var selectedValues = [];
            
            // Get all select elements within the same .upsell-product-info parent
            var variantOptions = $(this).closest('.upsell-product-info').find('.drawer-custom-variant-option-selector select');
            console.log(variantOptions);
            
            variantOptions.each(function() {
                console.log('option ', this);
                if (this.selectedIndex !== -1) {
                    var selectedValue = $(this).find('option:selected').val();
                    console.log('selectedValue ', selectedValue);
                    selectedValues.push(selectedValue);
                }
            });

            var displayValue = selectedValues.join(' / ');
            console.log('displayValue ', displayValue);

            // Find the .drawer-variant-option-js within the same parent and update its value
            var variantOptionElement = $(this).closest('.upsell-product-info').find('.drawer-variant-option-js');
            if (variantOptionElement.length) {
                variantOptionElement.val(displayValue).trigger('change');

                var selectedVarId = parseInt(variantOptionElement.find('option:selected').data('id'));
                console.log('selectedVarId ', selectedVarId);

                var upsell_product_price = variantOptionElement.find('option:selected').data('price');
                console.log('upsell_product_price ', upsell_product_price);
                $(this).closest('.upsell-product-info').find('.upsell-product-price').text(upsell_product_price);
                $(this).closest('.upsell-product-info').find('.upsell-atc-button').attr('data-variant-id', selectedVarId);

                var upsell_product_compare_price = variantOptionElement.find('option:selected').data('variant-compare-price');
                $(this).closest('.upsell-product-info').find('.upsell-product-compare-price').text(upsell_product_compare_price);

                if (upsell_product_price === upsell_product_compare_price) {
                    $(this).closest('.upsell-product-info').find('.upsell-product-compare-price').addClass('hidden');
                } else {
                    $(this).closest('.upsell-product-info').find('.upsell-product-compare-price').removeClass('hidden');
                }

                var grid_product_image = variantOptionElement.find('option:selected').data('image');
                console.log('grid_product_image ', grid_product_image);
                $(this).closest('.upsell-product-grid').find('.upsell-product-image img').attr("src", grid_product_image);
                console.log('last');
            }
        });

        function addToCart(variantId, quantity = 1) {
            var data = {
                items: [
                    {
                        id: variantId,
                        quantity: quantity
                    }
                ]
            };

            $.ajax({
                url: '/cart/add.js',
                method: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                success: function(cartItem) {
                    console.log('Item added to cart:', cartItem);
                    fetchCartDrawer();
                },
                error: function(error) {
                    console.error('Error adding item to cart:', error);
                }
            });
        }

        function fetchCartDrawer() {
            $.get('/?section_id=cart-drawer', function(carthtml) {
                var cartDrawerContent = $(carthtml).find('.checkout-form');
                console.log('-----------*****************---------------');
                
                if (cartDrawerContent.length) {
                    $('.checkout-form').html(cartDrawerContent.html());
                    console.log('Cart drawer updated');

                    // Fetch the updated cart total
                    $.getJSON('/cart.js', function(cart) {
                        const cartTotal = (cart.total_price / 100).toFixed(2);
                        console.log("Cart Total Amount:", cartTotal);

                        // Update the progress bar with the cart total
                        progressbarUpdate(cartTotal, 45);
                    }).fail(function(error) {
                        console.error("Error fetching cart total:", error);
                    });
                }
            }).fail(function(error) {
                console.error('Fetch error:', error);
            });
        }

        $(document).on('click', '.upsell-atc-button', function() {
            var variantId = $(this).data('variant-id');
            addToCart(variantId);
        });
   

